/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamDocumentSummary } from './PamDocumentSummary';
import {
    PamDocumentSummaryFromJSON,
    PamDocumentSummaryFromJSONTyped,
    PamDocumentSummaryToJSON,
} from './PamDocumentSummary';

/**
 * List response wrapper — an envelope object (not a raw array) so the response can grow without a breaking change.
 * @export
 * @interface PamDocumentSummaryList
 */
export interface PamDocumentSummaryList {
    /**
     * 
     * @type {Array<PamDocumentSummary>}
     * @memberof PamDocumentSummaryList
     */
    documents: Array<PamDocumentSummary>;
}

/**
 * Check if a given object implements the PamDocumentSummaryList interface.
 */
export function instanceOfPamDocumentSummaryList(value: object): value is PamDocumentSummaryList {
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function PamDocumentSummaryListFromJSON(json: any): PamDocumentSummaryList {
    return PamDocumentSummaryListFromJSONTyped(json, false);
}

export function PamDocumentSummaryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamDocumentSummaryList {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': ((json['documents'] as Array<any>).map(PamDocumentSummaryFromJSON)),
    };
}

export function PamDocumentSummaryListToJSON(value?: PamDocumentSummaryList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'documents': ((value['documents'] as Array<any>).map(PamDocumentSummaryToJSON)),
    };
}

